/**
 * Promise並列実行キュー
 */
var Queue = /** @class */ (function () {
    /**
     * @param maxConcurrent 並列数
     */
    function Queue(maxConcurrent) {
        if (maxConcurrent === void 0) { maxConcurrent = 5; }
        this.maxConcurrent = maxConcurrent;
        this.running = new Set();
        this.waiting = [];
        this.index = 1;
    }
    /**
     * キューに登録する
     *
     * @param func キューで実行するPromiseを返す関数
     * @returns キュー番号
     */
    Queue.prototype.enqueue = function (func) {
        if (this.error) {
            throw this.error;
        }
        var index = this.index++;
        if (this.running.size >= this.maxConcurrent) {
            this.waiting.push({ index: index, func: func });
        }
        else {
            this.run(index, func());
        }
        return index;
    };
    /**
     * キューが空になるまで待つ
     *
     * @returns Promise
     */
    Queue.prototype.wait = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.closer = function () {
                if (_this.error)
                    reject(_this.error);
                else
                    resolve();
            };
            if (_this.running.size === 0 && (_this.waiting.length === 0 || _this.error)) {
                _this.closer();
            }
        });
    };
    Queue.prototype.run = function (index, promise) {
        var _this = this;
        Promise.resolve(promise)
            .then(function () { return _this.resolved(index); })
            .catch(function (err) { return _this.rejected(index, err); });
        this.running.add(index);
    };
    Queue.prototype.resolved = function (index) {
        this.running.delete(index);
        var waits = this.waiting.shift();
        if (waits && !this.error) {
            var index_1 = waits.index, func = waits.func;
            this.run(index_1, func());
        }
        else if (this.closer && this.running.size === 0) {
            this.closer();
        }
    };
    Queue.prototype.rejected = function (index, err) {
        this.running.delete(index);
        this.error = err;
        if (this.closer && this.running.size === 0) {
            this.closer();
        }
    };
    return Queue;
}());
export { Queue };
